import Vue from "vue";
import api from "@/libs/api";
import {
  getToken,
  startCount,
  logoutUserRedirectToLogin,
  isUserLoggedIn,
} from "@/auth/utils";
import { modalGenericFillableError, modalGenericErrorWithRedirectHome } from '@/libs/sweetalerts'

const axiosIns = api;

// Adiciona o token nas requisições
axiosIns.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function verificaModaisExcecao(error,config) {
  if (error?.response?.data?.retry ||
    (config?.skipGlobalError && error?.response.status == 422)
  ){
    return Promise.reject(error)
  }
}

axiosIns.interceptors.response.use(
  (response) => {
    startCount();

    return response;
  },
  async (error) => {
    let status = error.response ? error.response.status : null;

    const config = error.config || {};
    
    if(status){
      if (
        isUserLoggedIn()
      ) {
        if (
          status === 400 ||
          status === 404 ||
          status === 409 ||
          status === 422
        ) {
          let mensagemErro = 'Ocorreu um erro na validação dos dados!</br>'
          let erroApi = error?.response?.data

          if(erroApi.error){
            mensagemErro += '</br><b>' + error.response.data.error + '</b>'
          } else if (erroApi.errors){
            Object.values(error.response.data.errors).forEach(value => {
              mensagemErro += '</br><b>' + value + '</b>'
            });
          }

          await verificaModaisExcecao(error,config)

          modalGenericFillableError(
            mensagemErro
          )
        } else if (status >= 500) {
          await modalGenericErrorWithRedirectHome()
        } else {
          logoutUserRedirectToLogin();
        }
      }
    } else {
      await modalGenericErrorWithRedirectHome()
    }

    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
